module.exports = __webpack_public_path__ + "static/media/tag.c42ff68a.svg";